export const customEvents = {
  getOtp: 'get_otp',
  otpVerifyLogin: 'otp_verify_login',
  otpVerifySignUp: 'otp_verify_signup',
  resendOtp: 'resend_otp',
  getOtpForForms: 'get_otp_for_forms',
  otpVerifyLoginForForms: 'otp_verified_for_forms',
  otpVerifySignUpForForms: 'otp_verify_signup',
  resendOtpForForms: 'resend_otp_for_forms'
};

export const clickIds = {
  troubleLoggingInLogin: 'trouble-logging-in-login',
  troubleLoggingInSignup: 'trouble-logging-in-signup',
  tAndCSignUp: 'terms-and-conditions-checkbox-signup',
  tAndCLogin: 'terms-and-conditions-checkbox-login'
};

export const otpVariants = {
  getOtp: 'getOtp',
  resendOtp: 'resendOtp'
};
